export enum MilestoneMessagesType {
  APPROACH = 'APPROACH',
  REACH = 'REACH'
}
